import React, { useEffect, useRef, useState } from 'react';
import { useDependencies } from '../dependencies';
import { Storage } from '../constants';

interface UseKinsideAuthReturn {
  token: string;
  refreshToken: string;
  userInfoRef: React.RefObject<HTMLInputElement>;
  searchInfoRef: React.RefObject<HTMLInputElement>;
  setTokenValues: () => void;
}

export const useKinsideAuth = (): UseKinsideAuthReturn => {
  const {
    stores: { parent, user },
  } = useDependencies();

  const [token, setToken] = useState<string>('');
  const [refreshToken, setRefreshToken] = useState<string>('');
  const userInfoRef = useRef<HTMLInputElement>(null);
  const searchInfoRef = useRef<HTMLInputElement>(null);

  const setTokenValues = (): void => {
    const parentObj = parent.parent;

    setToken(user.token?.token ?? '');
    setRefreshToken(user.token?.refreshToken?.token ?? '');

    if (userInfoRef.current && parentObj?.id) {
      if (parentObj.address?.city && parentObj.address?.state && parentObj.address?.zip) {
        userInfoRef.current.disabled = false;
        userInfoRef.current.value = JSON.stringify({
          address: {
            city: parentObj.address.city,
            state: parentObj.address.state,
            zip: parentObj.address.zip,
          },
        });
      } else {
        userInfoRef.current.disabled = true;
      }
    }

    if (searchInfoRef.current) {
      const geocodeData = JSON.parse(sessionStorage.getItem(Storage.GEOCODE_DATA_KEY) || '{}');

      if (geocodeData.zip || (geocodeData.city && geocodeData.state)) {
        searchInfoRef.current.disabled = false;
        searchInfoRef.current.value = JSON.stringify({
          address: {
            city: geocodeData.city,
            state: geocodeData.state,
            zip: geocodeData.zip,
          },
        });
      } else {
        searchInfoRef.current.disabled = true;
      }
    }
  };

  useEffect(() => {
    setTokenValues();
  }, []);

  return {
    token,
    refreshToken,
    userInfoRef,
    searchInfoRef,
    setTokenValues,
  };
};
